import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import GroupSvg from "../../assets/svg/Group.svg";
import rd from "../../assets/svg/reddownload.svg";
import Templateframe from "../../assets/svg/Templateframe.svg";
import Vector from "../../assets/svg/Vector.svg";
import Download from "../../assets/svg/vdownload.svg";
import { useNavigate } from "react-router-dom";
import { downloadBase64File, exportdata, getDockApi, getDownloadReportApi, getExportdownloadApis, getExportfieldApis, getLocationApi, getTempalteApi, getVehicleTypeApi, savetempalteApi } from "./report-api";
import { Row, Col } from "react-bootstrap";
import CommonAsyncSelect from "../common/custom-select";
import { Toast, ToastContainer } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import drop from "../../assets/svg/dropdown.svg";
import mytemp from "../../assets/svg/mytemplate.svg";
import download from "../../assets/svg/downsave.svg";
import previous from "../../assets/svg/previousexports.svg";
import TempalteModal from "../common/template-modal";
import mawalog from "../../assets/svg/mawaloglogo.svg";

const Docks = () => {
  //Exports & Templates

  const generateFields = () => {
    const fields = [];

    if (selectedLocation.length > 0) {
      fields.push({ label: "Location", value: JSON.stringify(selectedLocation), value1: JSON.stringify(selectedLocation) });
    }

    if (selectedVehicleType.length > 0) {
      fields.push({ label: "Vehicle_Type", value: JSON.stringify(selectedVehicleType), value1: JSON.stringify(selectedVehicleType) });
    }

    if (selectedDockType) {
      fields.push({ label: "Dock_Type", value: String(selectedDockType.value), value1: String(selectedDockType.label) });
    }

    if (selectedDock.length > 0) {
      fields.push({ label: "Dock", value: JSON.stringify(selectedDock), value1: JSON.stringify(selectedDock) });
    }

    if (selectedStatus) {
      fields.push({ label: "Status", value: String(selectedStatus.value), value1: String(selectedStatus.label) });
    }

    if (startDate) {
      fields.push({ label: "Created Date", value: `${startDate} - ${endDate}`, value1: `${startDate} - ${endDate}` });
    }
    return fields;
  };

  const applyFieldsFromAPI = (fieldsFromAPI) => {
    if (!Array.isArray(fieldsFromAPI)) {
      console.error("Expected an array for fieldsFromAPI, but got:", fieldsFromAPI);
      return;
    }

    fieldsFromAPI.forEach((field) => {
      switch (field.label) {
        case "Location": {
          try {
            const parsed = JSON.parse(field.value);
            setSelectedLocation(parsed);
          } catch (e) {
            console.error("Error parsing Location value:", field.value);
          }
          break;
        }

        case "Vehicle_Type": {
          try {
            const parsed = JSON.parse(field.value);
            setSelectedVehicleType(parsed);
          } catch (e) {
            console.error("Error parsing Vehicle_Type value:", field.value);
          }
          break;
        }

        case "Dock_Type": {
          setSelectedDockType({
            value: field.value,
            label: field.value1,
          });
          break;
        }

        case "Dock": {
          try {
            const parsed = JSON.parse(field.value);
            setSelectedDock(parsed);
          } catch (e) {
            console.error("Error parsing Dock value:", field.value);
          }
          break;
        }

        case "Status": {
          setSelectedStatus({
            value: field.value,
            label: field.value1,
          });
          break;
        }

        case "Created Date": {
          const fromDateObj = startDate;
          const toDateObj = endDate;
          startDate([fromDateObj, toDateObj]);
          break;
        }

        default:
          break;
      }
    });
  };

  

  const openModal = () => {
    console.log("open modal called");
    setIsOpen(true);
    setIsScannerActive(true);
  };

  const [validations, setValidations] = useState({
    name: "",
    fields: "",
  });

  const [isOpen, setIsOpen] = useState(false);
  const [isScannerActive, setIsScannerActive] = useState(true);

  const [myTemplates, setmyTemplates] = useState([]);
  const [previousTemplates, setpreviousTemplates] = useState([]);

  const [selectedMy, setSelectedMy] = useState(null);
  const [selectedPrev, setSelectedPrev] = useState(null);
  const [searchMy, setSearchMy] = useState("");
  const [searchPrev, setSearchPrev] = useState("");
  const [openMy, setOpenMy] = useState(false);
  const [openPrev, setOpenPrev] = useState(false);

  const getTemplate = async () => {
    try {
      const response = await getTempalteApi();
      console.log("API response:", response);

      if (response.success === true) {
        setmyTemplates(response.templates);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

  const getPreviousTemplate = async () => {
    try {
      const response = await getDownloadReportApi();
      console.log("API getPreviousTemplate response:", response);

      if (response.success === true) {
        setpreviousTemplates(response.templates);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

  const getExportfield = async (id) => {
    try {
      const response = await getExportfieldApis(id);
      console.log("API response:", response);

      if (response.success === true) {
        applyFieldsFromAPI(response.template.fields);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

  const getExportdownlaod = async (id) => {
    try {
      const response = await getExportdownloadApis(id);
      console.log("API response:", response);

      if (!response.success || !response.url) {
        console.warn("Response is missing 'success' flag or 'url':", response);
        return;
      }

      const fileUrl = response.url;
      const fileName = response.file_name;

      // Fetch the file as a blob
      const fileResponse = await fetch(fileUrl);
      const blob = await fileResponse.blob();

      // Create a download link from blob
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName; // Optional: set your desired filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up blob URL
      window.URL.revokeObjectURL(blobUrl);

      console.log("Download triggered successfully.");
    } catch (error) {
      console.error("Download failed:", error);
      alert(`Download failed: ${error.message}`);
    }
  };

  const saveTempalte = async (templateName, fieldsList) => {
    const bodydata = {
      application: "Dock",
      name: templateName,
      fields: fieldsList,
    };
    try {
      const response = await savetempalteApi(bodydata);

      if (response.status === 400) {
        const errorData = response?.data?.error || {};

        const validationTemp = {
          name: errorData?.name?.[0] || "",
          fields: errorData?.fields?.[0] || "",
        };

        console.log("response.data.error...", errorData);
        console.log("validationTemp...", validationTemp);

        setValidations(validationTemp);
        console.log("validations...", validations);
      } else {
        if (response.data.success === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
          getTemplate();
          console.log("successful");
          setIsOpen(false);
        } else {
          console.warn("Unexpected response or success flag missing:", response);
        }
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

  useEffect(() => {
    getTemplate();
    getPreviousTemplate();
  }, []);

  //Exports & previous Templates over

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);

  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [showSnackbar, setShowSnackbar] = useState(false);

  //created date
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const fromCreatedDate = startDate ? format(startDate, "yyyy-MM-dd") : "";
  const toCreatedDate = endDate ? format(endDate, "yyyy-MM-dd") : "";

  const dockTypeOptions = [
    { label: "All", value: "" },
    { label: "Load In", value: "load_in" },
    { label: "Load Out", value: "load_out" },
  ];

  const statusOptions = [
    { label: "All", value: "All" },
    { label: "In Queue", value: "In-Queue" },
    { label: "Dock In", value: "Dock-In" },
    { label: "On Time", value: "On-Time" },
    { label: "Delay", value: "Delay" },
    { label: "Over Delay", value: "Over-Delay" },
    { label: "Dock Out", value: "Dock-Out" },
    { label: "Out Queue", value: "Out-Queue" },
  ];

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#f8f8f8",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#8790A1",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#ffecec" : state.isFocused ? "#fff5f6" : "#ffffff",
      color: state.isSelected ? "#d35258" : "#212129",
      fontWeight: state.isSelected ? "600" : "500",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "f8f9fb",
        color: "#212129",
      },
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  //reset button
  const handleReset = () => {
    setSelectedDockType(null);
    setSelectedStatus(null);
    setSelectedDock([]);
    setSelectedVehicleType([]);
    setSelectedLocation([]);
    setStartDate(null);
    setEndDate(null);
    setSelectedMy(null);
  };

  //handle options

  const handleLocationChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);
    //setSelectedTransportLabels(selectedOptions.map((option) => option.value));
  };
  const handleVehicleTypeChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedVehicleType(selectedOptions);
    //setSelectedTransportLabels(selectedOptions.map((option) => option.value));
  };
  const handleDockChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedDock(selectedOptions);
    //setSelectedTransportLabels(selectedOptions.map((option) => option.value));
  };
  //
  const handleStatusChange = (selectedOptions) => {
    setSelectedStatus(selectedOptions || null);
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const navigate = useNavigate();
  const [showPopMenu, setShowPopMenu] = useState(false);
  const [showExportedPop, setShowExportedPop] = useState(false);

  //dropdown variables

  const [location, setLocation] = useState("");
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [vehicleType, setVehicleType] = useState("");
  const [selectedVehicleType, setSelectedVehicleType] = useState([]);
  const [dock, setDock] = useState("");
  const [selectedDock, setSelectedDock] = useState([]);
  const [status, setStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDockType, setSelectedDockType] = useState(null);

  const getDockTypeData = async (inputValue) => {
    return dockTypeOptions.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()));
  };

  const getStatusData = async (inputValue) => {
    return statusOptions.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()));
  };

  const handleDockTypeChange = (selectedOptions) => {
    setSelectedDockType(selectedOptions || "");
  };

  //location api
  const getLocationData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getLocationApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  //vehicle type api
  const getVehicleTypeData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getVehicleTypeApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  //Dock api
  const getDockData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getDockApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const popMenuRef = useRef(null);
  const exportedPopRef = useRef(null);

  const togglePopMenu = () => {
    setShowPopMenu((prev) => {
      const newState = !prev;
      if (newState) setShowExportedPop(false);
      return newState;
    });
  };

  const toggleExportedPop = () => {
    setShowExportedPop((prev) => {
      const newState = !prev;
      if (newState) setShowPopMenu(false);
      return newState;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popMenuRef.current && !popMenuRef.current.contains(event.target) && exportedPopRef.current && !exportedPopRef.current.contains(event.target)) {
        setShowPopMenu(false);
        setShowExportedPop(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const exportApi = async () => {
    console.log("selectedVehicleType");

    console.log(selectedVehicleType);
    const bodydata = {
      dock_type: selectedDockType?.value || "",
      status: selectedStatus?.value || null,
      vehicletype_id: selectedVehicleType?.filter((item) => item.value !== "").map((item) => item.value),
      location_id: selectedLocation?.filter((item) => item.value !== "").map((item) => item.value),
      from_date: fromCreatedDate,
      to_date: toCreatedDate,
      dock_id: selectedDock?.filter((item) => item.value !== "").map((item) => item.value),
    };
    console.log(bodydata);

    const response = await exportdata(bodydata);
    console.log(response);
    if (response.status === 200) {
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      if (response.data.success === true) {
        const base64String = response.data.base64;
        const fileName = response.data.file_name;
        downloadBase64File(base64String, fileName);
        getPreviousTemplate();
      }
    }
  };

  return (
    <div>
      <style>{`
  .custom-datepicker {
    background-color: #F8F8F8 !important;
    color: #172b4d !important;
    font-weight: 500 !important;
    font-size: 13px !important;
    cursor: pointer;
    height:40px;
  }

  .custom-datepicker::placeholder {
    color: #8790A1 !important;
    font-weight: 500;
    font-size: 13px;
  }
`}</style>

      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="container my-5" style={{ paddingBottom: "24px" }}>
        {/* Header Section */}
        <div
          className="p-4 d-flex flex-column flex-lg-row align-items-center justify-content-between rounded-5"
          style={{
            background: "linear-gradient(180deg, #FFE9EA 0%, #C4FFED 100%)",
            borderRadius: "24px",
          }}>
          <div className="text-center text-lg-start mb-4 mb-lg-0" style={{ maxWidth: "600px" }}>
            <div className="d-flex justify-content-center justify-content-lg-start bg-white rounded-pill border mb-3 p-1 shadow-sm" style={{ maxWidth: "fit-content" }}>
              <button className="btn rounded-pill px-4 py-2 text-dark" style={{ backgroundColor: "transparent" }} onClick={() => navigate("/quick-report")}>
                Quick report
              </button>
              <button className="btn btn-danger rounded-pill px-4 py-2 fw-bold">Customized</button>
            </div>
            <h2 className="fw-bold text-dark mb-2" style={{ fontSize: "1.75rem" }}>
              Customizable export
            </h2>
            <p className="text-dark" style={{ fontSize: "1rem", color: "#333" }}>
              Access your data effortlessly with customizable export options—streamline, optimize, and take control of your insights in just a few clicks.
            </p>
          </div>

          <div className="text-center">
            <img src={GroupSvg} alt="Illustration" className="img-fluid" style={{ maxHeight: "220px" }} />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center my-4 gap-3">
          <div className="fw-bold fs-5 text-dark">Export your report</div>
          <div className="d-flex flex-column flex-sm-row gap-3">
            <div style={{ position: "relative" }}>
              <div onClick={() => setOpenMy(!openMy)} style={{ display: "flex", alignItems: "center", borderRadius: "100px", padding: "16px", backgroundColor: "#F8F8F8", gap: "5px", cursor: "pointer" }}>
                <img src={mytemp} style={{ width: "16px" }} />
                <div style={{ fontSize: "13px", fontWeight: "500", color: "#172B4D" }}>{selectedMy || "My templates"}</div>
                <img src={drop} style={{ marginLeft: "12px" }} />
              </div>

              {openMy && (
                <div style={{ position: "absolute", top: "100%", backgroundColor: "#fff", border: "1px solid #ddd", borderRadius: "8px", marginTop: "5px", maxHeight: "250px", overflowY: "auto", zIndex: 100 }}>
                  <input type="text" placeholder="Search..." value={searchMy} onChange={(e) => setSearchMy(e.target.value)} style={{ padding: "8px 12px", width: "100%", border: "none", borderBottom: "1px solid #eee", outline: "none" }} />
                  {myTemplates
                    ?.filter((item) => item.label.toLowerCase().includes(searchMy.toLowerCase()))
                    .map((item, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          setSelectedMy(item.label);
                          setOpenMy(false);
                          setSearchMy("");
                          getExportfield(item.value);
                        }}
                        style={{ padding: "10px 12px", cursor: "pointer" }}>
                        {item.label}
                      </div>
                    ))}
                </div>
              )}
            </div>

            <div style={{ position: "relative" }}>
              <div
                onClick={() => setOpenPrev(!openPrev)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "100px",
                  padding: "16px",
                  backgroundColor: "#F8F8F8",
                  gap: "5px",
                  cursor: "pointer",
                }}>
                <img src={previous} style={{ width: "16px" }} />
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#172B4D",
                  }}>
                  Previous exports
                </div>
                <img src={drop} style={{ marginLeft: "12px" }} />
              </div>

              {openPrev && (
                <div style={{ position: "absolute", top: "100%", backgroundColor: "#fff", border: "1px solid #ddd", borderRadius: "8px", marginTop: "5px", maxHeight: "250px", overflowY: "auto", zIndex: 100 }}>
                  <input type="text" placeholder="Search..."  onChange={(e) => setSearchPrev(e.target.value)} style={{ padding: "8px 12px", width: "100%", border: "none", borderBottom: "1px solid #eee", outline: "none" }} />
                  {previousTemplates
                    ?.filter((item) => item.label.toLowerCase().includes(searchPrev.toLowerCase()))
                    .map((item, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          setSelectedPrev(item.label);
                          setOpenPrev(false);
                          setSearchPrev("");
                          getExportdownlaod(item.value);
                        }}
                        style={{ padding: "10px 12px", cursor: "pointer" }}>
                        {item.label}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col sm={12} md={6} lg={4}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Location</div>
                <div>
                  <CommonAsyncSelect isMulti cacheOptions value={selectedLocation} loadOptions={getLocationData} onChange={handleLocationChange} defaultOptions placeholder="Select locations" />
                </div>
              </div>
            </Col>

            <Col sm={12} md={6} lg={4}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Vehicle Type</div>
                <div>
                  <CommonAsyncSelect isMulti cacheOptions value={selectedVehicleType} loadOptions={getVehicleTypeData} onChange={handleVehicleTypeChange} defaultOptions placeholder="Select Vehicle Type" />
                </div>
              </div>
            </Col>

            <Col sm={12} md={6} lg={4}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Dock Type</div>
                <div>
                  <CommonAsyncSelect cacheOptions value={selectedDockType} loadOptions={getDockTypeData} onChange={handleDockTypeChange} defaultOptions={dockTypeOptions} placeholder="Select Dock Type" />
                </div>
              </div>
            </Col>
          </Row>

          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col sm={12} md={6} lg={4}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Created Date</div>
                <DatePicker selected={startDate} onChange={handleDateChange} startDate={startDate} endDate={endDate} selectsRange placeholderText="Select date range" className="form-control rounded-3 custom-datepicker" style={{ backgroundColor: "#F8F8F8", color: "#8790A1", cursor: "pointer" }} />
              </div>
            </Col>

            <Col sm={12} md={6} lg={4}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Dock</div>
                <div>
                  <CommonAsyncSelect isMulti cacheOptions value={selectedDock} loadOptions={getDockData} onChange={handleDockChange} defaultOptions placeholder="Select Dock" />
                </div>
              </div>
            </Col>

            <Col sm={12} md={6} lg={4}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Status</div>
                <div>
                  <CommonAsyncSelect cacheOptions value={selectedStatus} loadOptions={getStatusData} onChange={handleStatusChange} defaultOptions={statusOptions} placeholder="Select Status" />
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* Footer Buttons */}
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center my-4 gap-3">
          <button onClick={() => openModal()} style={{ borderRadius: "100px", border: "1px solid #D35258", padding: "10px 16px", display: "flex", gap: "8px", backgroundColor: "#FFFFFF" }}>
            <img src={rd} style={{ width: "16px", color: "#D35258" }} />
            <div style={{ fontWeight: "600", fontSize: "13px", color: "#D35258" }}>Save as template</div>
          </button>

          <div className="d-flex justify-content-end gap-2">
            <button className="px-4 py-2 fw-semibold bg-white  text-dark rounded-pill" onClick={handleReset} style={{ border: "1px solid #e5e5e5" }}>
              Reset
            </button>
            <button className="px-4 py-2 fw-semibold text-white  border-0 rounded-pill" onClick={() => exportApi()} style={{ backgroundColor: "#D35258" }}>
              Export
            </button>
          </div>
        </div>
        <div style={{textAlign: "center", marginTop: "80px",fontWeight:"400",fontSize:'12px',color:'#172B4D'}}>
          Powered by <span><img src={mawalog}/></span>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <TempalteModal
        isVisible={isOpen}
        validations={validations}
        onCancel={() => {
          console.log("Cancel tapped");
          setIsOpen(false);
          setValidations({
            name: "",
            fields: "",
          });
        }}
        onSave={(templateName) => {
          const fieldsList = generateFields();
          saveTempalte(templateName, fieldsList);
        }}
      />
    </div>
  );
};

export default Docks;
